import { AxiosRequestConfig } from "axios";
import { useAccessToken } from "./useAccessToken";

/**
 * Returns axios config for improve-api requests.
 * Uses the same PropelAuth token that works with improve-service.
 */
export const useImproveAxios = () => {
	const accessToken = useAccessToken();

	const baseURL = process.env.REACT_APP_IMPROVE_API_URL;
	if (!baseURL) {
		throw new Error("REACT_APP_IMPROVE_API_URL is not set");
	}

	const config: AxiosRequestConfig = {
		baseURL: baseURL,
		headers: accessToken ? {
			Authorization: `Bearer ${accessToken}`,
		} : {},
	};
	return config;
};